var _path, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8212 12.8229C11.0896 13.1233 11.0515 13.5741 10.736 13.8298C10.4205 14.0854 9.94716 14.0491 9.67875 13.7486L5.95638 9.58188C5.8413 9.45306 5.57182 9.10637 5.57182 9.10637C5.57182 9.10637 5.82889 8.80659 5.94334 8.67116L9.66571 4.26646C9.92542 3.95914 10.3975 3.91052 10.7202 4.15787C11.0429 4.40521 11.094 4.85485 10.8342 5.16216L7.50103 9.10637L10.8212 12.8229Z",
    fill: "#EAEDF3"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 4,
    width: 7,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8212 12.8229C11.0896 13.1233 11.0515 13.5741 10.736 13.8298C10.4205 14.0854 9.94716 14.0491 9.67875 13.7486L5.95638 9.58188C5.8413 9.45306 5.57182 9.10637 5.57182 9.10637C5.57182 9.10637 5.82889 8.80659 5.94334 8.67116L9.66571 4.26646C9.92542 3.95914 10.3975 3.91052 10.7202 4.15787C11.0429 4.40521 11.094 4.85485 10.8342 5.16216L7.50103 9.10637L10.8212 12.8229Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.2fd20a510a403f1e5b0eb478e553fc86.svg";
export { ForwardRef as ReactComponent };